/* eslint-disable react-hooks/exhaustive-deps */

import React, { useContext, useEffect } from "react";
import { TableRow, TableCell, Paper } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  IconButtonDatatable,
  DatatablesFooterServerSide,
  Loading,
  SearchInput,
} from "App/Component/ui";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { headCells } from "./helpers";
import { SelectIcon } from "App/Assets";
import { formatNumber, isNull } from "App/utils/helpers";
import { FormContext } from "../../../context/FormContext";
import { FreezeTable } from "components/organism";
import { useDebounce } from "hooks";

export default function DaftarBarang({
  rows,
  totalData,
  loading,
  setNewDataBarangByKelas,
  setFormFilterBarangByKelas,
  formFilterBarangByKelas,
  handleClickSelect,
}) {
  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewDataBarangByKelas });

  const debounceSearchInput = useDebounce(
    formFilterBarangByKelas.barang_name,
    300
  );

  const handleSearchInput = () => {
    if (!isNull(formFilterBarangByKelas.barang_name)) {
      setNewDataBarangByKelas(
        formFilterBarangByKelas.pages,
        formFilterBarangByKelas.limit,
        {
          barang_name: formFilterBarangByKelas.barang_name,
        }
      );
    } else {
      setNewDataBarangByKelas(
        formFilterBarangByKelas.pages,
        formFilterBarangByKelas.limit,
        {
          barang_name: null,
        }
      );
    }
  };

  useEffect(() => {
    handleSearchInput();
  }, [debounceSearchInput]);

  return (
    <>
      <Paper
        style={{
          padding: "1rem",
        }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <p className='fw-600 fs-14'>Daftar Barang</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}>
            <div>
              <SearchInput
                withIcon={true}
                heightInput='0.4'
                onchange={(e) => {
                  setFormFilterBarangByKelas((prev) => {
                    return {
                      ...prev,
                      barang_name: e.target.value,
                    };
                  });
                }}
              />
            </div>
          </div>
        </div>
        <Loading show={loading} />
        <div className='mt-1'>
          <TableDaftarBarang
            rows={rows}
            handleClickSelect={handleClickSelect}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </div>
      </Paper>
    </>
  );
}

export const TableDaftarBarang = ({ rows, handleClickSelect }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "namaBarang",
    orderByRow: ["namaBarang"],
  });

  const { formData } = useContext(FormContext);

  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      maxHeight='400px'
      orderBy={orderBy}>
      {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
        return (
          <TableRow key={index}>
            <TableCell scope='row' padding='none' width='5%' align='center'>
              {index + 1}
            </TableCell>
            <TableCell scope='row' width='10%' padding='none' align='center'>
              {!formData.is_lock && !formData.is_close && (
                <IconButtonDatatable
                  color='secondary'
                  aria-label='delete'
                  onClick={() => handleClickSelect(row)}
                  style={{
                    background: "#D8D8D8",
                    padding: "5px 4px",
                  }}>
                  <SelectIcon width={"14"} height={"14"} fill={"#fff"} />
                </IconButtonDatatable>
              )}
            </TableCell>
            <TableCell align='left' width='10%'>
              {row?.barang_id}
            </TableCell>
            <TableCell align='left'>{row?.namaBarang}</TableCell>
            <TableCell align='left'>{formatNumber(row?.qty)}</TableCell>
            <TableCell align='left' width='10%'>
              {formatNumber(row?.hargaJual)}
            </TableCell>
            <TableCell align='left'>{row?.namaSatuanJual}</TableCell>
            <TableCell align='left'>{row?.namaGudang}</TableCell>
          </TableRow>
        );
      })}
      {rows.length === 0 && (
        <TableRow>
          <TableCell align='center' colSpan={headCells.length}>
            Tidak ada data
          </TableCell>
        </TableRow>
      )}
    </FreezeTable>
  );
};
